export enum RoleTypeEnum {
    Admin = 'Admin',
    FleetPerformanceAnalyst = 'FleetPerformanceAnalyst',
    OtherOdfjellUser = 'OtherOdfjellUser',
    ShipOperator = 'ShipOperator',
    ShipUser = 'ShipUser',
    Unknown = 'Unknown',
}
